// extracted by mini-css-extract-plugin
export default {"info":"MemberLicenseInfo_info__uFU+v"};